module.exports = __webpack_public_path__ + "static/media/253-seychelles.2fe6ea96.svg";